import { useState } from 'react'
import { Box, OutlinedInput, Typography } from "@mui/material"
import { BooleanEntryValue } from "./BooleanEntryValue"
import EntryPopover from './EntryPopover'

export default function EntryValue({...params}){
    let pageMode = params.pageMode

    let stateObject = params.stateObject
    let setStateObjectEntryFieldHelper = params.setStateObjectEntryFieldHelper

    let title = params.title
    let toggleFocus = params.toggleFocus

    let placeholder = ''
    if (stateObject[title].oldValue === "" && stateObject[title].currentValue === undefined && stateObject[title].currentInput === undefined) placeholder = "—"
    else if (stateObject[title].oldValue !== "" && stateObject[title].currentValue === "") placeholder = "—"
    else if (stateObject[title].currentValue === undefined && stateObject[title].currentInput === undefined) placeholder = stateObject[title].oldValue
    else if (stateObject[title].currentValue !== undefined && stateObject[title].currentInput === undefined) placeholder = stateObject[title].currentValue
    else if (stateObject[title].currentInput !== undefined) placeholder = stateObject[title].currentInput
    

    const inputChanged = (event) => {
        event.preventDefault()
        setStateObjectEntryFieldHelper(title, 'currentInput', event.target.value)
        setStateObjectEntryFieldHelper(title, 'validState', true)
    }

    const handleBlur = (event) => {
        event.preventDefault()
        toggleFocus(event)
    }

    let [popoverAnchor, setPopoverAnchor] = useState(null)
    const togglePopover = (event) => {
        if (popoverAnchor === null) setPopoverAnchor(event.currentTarget)
        else if (popoverAnchor !== null) setPopoverAnchor(null)
    }
    const closePopover = () => {setPopoverAnchor(null)}

    return (
        <>
            {/*special case for boolean red x and green checkmark */}
            {(typeof stateObject[title].oldValue === 'boolean') ? (
                <BooleanEntryValue pageMode={pageMode} stateObject={stateObject} setStateObjectEntryFieldHelper={setStateObjectEntryFieldHelper} 
                                    title={title}/>
            )
            
            /* normal read mode  (top picture)*/
            :(pageMode === 'read') ? (
                <Box display={'flex'} mx={'5px'} overflow={'hidden'} textOverflow={'ellipsis'} onClick={togglePopover}>
                    <Typography noWrap alignSelf={'center'} fontSize={'18px'} fontWeight={400}>{String(placeholder)}</Typography>
                    <EntryPopover value={String(placeholder)} popoverAnchor={popoverAnchor} closePopover={closePopover}/>
                </Box>
            )
            //*above and below are the same*//
            /* edit mode, unedited, locked  (Row 1)*/
            :(pageMode === 'edit' && !stateObject[title].updatedState && stateObject[title].lockState) ? (
                <Box display={'flex'} mx={'5px'} overflow={'hidden'} textOverflow={'ellipsis'} onClick={togglePopover}>
                    <Typography noWrap alignSelf={'center'} fontSize={'18px'} fontWeight={400}>{String(placeholder)}</Typography>
                    <EntryPopover value={String(placeholder)} popoverAnchor={popoverAnchor} closePopover={closePopover}/>
                </Box>
            )
            //this one also
            /* edit mode, updated, locked  (Row 11) (green lock case)*/
            :(pageMode === 'edit' && stateObject[title].updatedState && stateObject[title].lockState) ? (
                <Box display={'flex'} mx={'5px'} overflow={'hidden'} textOverflow={'ellipsis'} onClick={togglePopover}>
                    <Typography noWrap alignSelf={'center'} fontSize={'18px'} fontWeight={400}>{String(placeholder)}</Typography>
                    <EntryPopover value={String(placeholder)} popoverAnchor={popoverAnchor} closePopover={closePopover}/>
                </Box>
            )


            /* edit mode, updated or not updated, unlocked, unfocused  (Row 3)*/
            :(pageMode === 'edit' && !stateObject[title].lockState && !stateObject[title].focusState) ? (
                <Typography noWrap onClick={toggleFocus} alignSelf={'center'} fontSize={'18px'} fontWeight={400} overflow={'hidden'} textOverflow={'ellipsis'}>{String(placeholder)}</Typography>
            )


            /* edit mode, unlocked, not updated, focused  (Row 6)*/
            :(pageMode === 'edit' && !stateObject[title].lockState && !stateObject[title].updatedState && stateObject[title].focusState) ? (
                <OutlinedInput
                    placeholder={placeholder }
                    onChange={inputChanged}
                    disabled={stateObject[title].lockState}
                    autoFocus
                    onBlur={(event) => handleBlur(event)}
                    inputProps={{ style: { textAlign: 'center' } }}
                    sx={{
                        '& .MuiInputBase-root': {height: '44px', width: '158px'},
                        '& .MuiInputBase-input': {padding: '0px', fontSize:'18px'},
                        '& .MuiOutlinedInput-input': {
                            backgroundColor: '#000000',
                            border: (stateObject[title].validState) ? '3px solid #1993FF' : '3px solid red',
                            height: '44px',
                        },
                        '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: 'transparent !important',
                        },
                        display:'flex',
                        alignItems:'center',
                        justifyContent:'center'
                    }}
                />
            )


            /* edit mode, unlocked, updated, focused  (Row 7)*/
            :(pageMode === 'edit' && !stateObject[title].lockState && stateObject[title].updatedState && stateObject[title].focusState) && (
                <OutlinedInput
                    placeholder={placeholder}
                    defaultValue={(placeholder !== "—") ? placeholder : ""}
                    onChange={inputChanged}
                    disabled={stateObject[title].lockState}
                    autoFocus
                    onBlur={(event) => handleBlur(event)}
                    inputProps={{ style: { textAlign: 'center' } }}
                    sx={{
                        '& .MuiInputBase-root': {height: '44px', width: '158px'},
                        '& .MuiInputBase-input': {padding: '0px', fontSize:'18px'},
                        '& .MuiOutlinedInput-input': {
                            backgroundColor: '#000000',
                            border: (stateObject[title].validState) ? '3px solid #1993FF' : '3px solid red',
                            height: '44px',
                        },
                        '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: 'transparent !important',
                        },
                        display:'flex',
                        alignItems:'center',
                        justifyContent:'center'
                    }}
                />
            )}
        </>
    )
}
